import client from '../httpClient';

// sendmail016
const getSendRecommendMails = (params) => {
  return client.get('/send-mails/recommend/counts', { params });
};

export default getSendRecommendMails;
